export const EVENTS = {
  CURRENTTIME_CHANGE: 'setcurrenttime', // 当前时间改变
  LOOP_CHANGE: 'loopchange', // 循环状态改变
  MUTE_CHANGE: 'mutedchange', // 静音状态改变
  RATE_CHANGE: 'ratechange', // 倍速改变
  VOLUME_CHANGE: 'volumechange', // 音量改变
  DEFINITION_CHANGE: 'definitionchange', // 当前清晰度变化
  /** 重新调度完成 */
  REFRESH_DISPATCH_COMPLETED: 'refreshDispatchCompleted',
  PAUSE: 'pause', // 暂停
  ERROR: 'error', // 播放器出错
  ENDED: 'ended', // 播放完毕
  TIMEUPDATE: 'timeupdate', // 时间改变事件
  LOADED: 'loadeddata_ext', // 当前帧的数据加载完成
  PLAY: 'play_ext', // 调用播放
  CANPLAY: 'canplay',
  PLAYING: 'playing', // 视频正在播放
  PROGRESS: 'progress_ext', // 视频加载中
  LOADEDMETADATA: 'loadedmetadata_ext', // 视频元数据加载完成
  OPEN_SUBTITLE: 'openSubtitle', // 开启字幕
  CLOSE_SUBTITLE: 'closeSubtitle', // 关闭字幕
  SUBTITLE_CHANGED: 'subtitleChanged', // 字幕文件改变事件
  LIVESUBTITLE_OPENED: 'liveSubtitleOpened', // 直播字幕开启事件
  LIVESUBTITLE_CLOSED: 'liveSubtitleClosed', // 直播字幕关闭事件
  CHANGEKERNEL: 'changekernel', // 降级内核
  CHANGEKERNELDATA: 'changekerneldata', // 降级内核重新解析调度数据
  CHANGE_SCHEDULER_DATA: 'changeschedulerdata',
  AUTOPLAY_SUCCESS: 'autoplaySuccess', // 自动播放成功
  AUTOPLAY_FAILED: 'autoplayFailed', // 自动播放失败事件
  SUBTITLE_LOADED: 'subtitleLoaded', //点播字幕加载成功

  // todo: 事件未按常量引入
  FULLSCREEN_CHANGE: 'fullscreenchanged', // 全屏状态改变
  LAG_REPORT: 'lagreport', // 卡顿
  LAG_RECOVER: 'lagrecover', // 卡顿恢复
  OPEN_BARRAGE: 'openbarrage', // 开启弹幕
  CLOSE_BARRAGE: 'closebarrage', // 关闭弹幕
  CLEAR_BARRAGE: 'clearbarrage', // 清空弹幕
  DANMAKU_SETTING_CHANGE: 'DanmakuSettingChange', // 弹幕设置变更
  ENTER_PICTURE_IN_PICTURE: 'enterPictureInPicture', // 进入画中画
  EXIT_PICTURE_IN_PICTURE: 'exitPictureInPicture', // 退出画中画

  // todo: 注意可能有坑或者事件可能不全！
  // 以下事件在发送时可能比成功回调执行的早，故success回调后有可能漏过监听。增加转发
  PLAY_IN: 'play', // 播放
  PROGRESS_IN: 'progress', // 视频加载中
  LOADEDMETADATA_IN: 'loadedmetadata', // 视频元数据加载完成
  LOADED_IN: 'loadeddata' // 第一帧数据加载完成后触发
};

export const API_URL = {
  INIT: '/v2/init/start', // 初始化接口
  INIT_LIVE: '/v2/room/get-watch-info', // 直播观看初始化
  INIT_VOD: '/v2/demand/get-record-watch-info' // 点播观看初始化
};

export const KV = {
  APP_ID: 'app_id',
  THIRD_PARTY_USER_ID: 'third_party_user_id',
  CLIENT: 'client',
  ACCESS_TOKEN: 'access_token',
  PACKAGE_CHECK: 'package_check',
  LANGUAGE: 'language'
};

// 播放器可选主题
export const THEMEOPTIONS = ['classic', 'light'];

export const MUTILSUBTITLE = {
  subtitle_zh: '中文（简体）',
  subtitle_en: 'English（UK）',
  subtitle_en_US: 'English（US）',
  subtitle_ja: '日本语',
  subtitle_ru: 'Россия',
  subtitle_tr: 'Türk',
  subtitle_fr: 'Français',
  subtitle_es: 'español',
  subtitle_it: 'Italiano',
  subtitle_pl: 'Polski',
  subtitle_de: '	Deutsch',
  subtitle_nl: 'Nederlands',
  subtitle_th: 'ไทย',
  subtitle_vi: 'Tiếng Việt',
  subtitle_uk: 'українська'
};

export const VODSUBTITLE = {
  zh: '中文（简体）',
  en: 'English（UK）',
  en_US: 'English（US）',
  ja: '日本语',
  ru: 'Россия',
  tr: 'Türk',
  fr: 'Français',
  es: 'español',
  it: 'Italiano',
  pl: 'Polski',
  de: '	Deutsch',
  nl: 'Nederlands',
  th: 'ไทย',
  vi: 'Tiếng Việt',
  uk: 'українська'
};
